handleNCG